"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = midiMessageHandler;

var _sysexOSC = _interopRequireDefault(require("./sysexOSC"));

var _utilities = require("./utilities");

var events = _interopRequireWildcard(require("./eventNames"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

let isPreset = false;

function midiMessageHandler(event, device) {
  let data = event.data;

  switch (data[0]) {
    case 240:
      const oscMessage = (0, _sysexOSC.default)(data),
            address = oscMessage.address;
      let eventName = 'error',
          parsedOSC = (0, _utilities.parseOSC)(oscMessage);

      if (address.includes('/p/')) {
        if (address.includes('begin')) {
          isPreset = true;
          eventName = events.PRESETBEGIN;
        } else if (address.includes('end')) {
          isPreset = false;
          eventName = events.PRESETEND;
        } else {
          if (isPreset) {
            eventName = events.PRESETCHUNK;
          } else {
            eventName = events.PRESETPARAM;
          }
        }
      } else if (address.includes('/g/')) {
        eventName = events.GLOBALPARAM;
      } else if (address.includes('/uc/')) {
        eventName = events.USERCURVE;
      } else if (address.includes('/fw/')) {
        if (address.includes('ready')) {
          eventName = events.FWREADY;
        } else if (parsedOSC.param === 'version') {
          eventName = events.FIRMWAREVERSION;
        }
      } else if (address.includes('/d/')) {
        let controlType = address.replace('/d/', '');

        if (controlType === 'rawVelocity') {
          eventName = events.RAWVELOCITY;
          parsedOSC = {
            param: 'rawVelocity',
            values: [...parsedOSC.values]
          };
        } else {
          eventName = events.UI;
          parsedOSC = {
            param: 'ui',
            values: [controlType, ...parsedOSC.values]
          };
        }
      }

      switch (parsedOSC.param) {
        case 'barGain':
          eventName = events.BARGAIN;
          break;

        case 'barGains':
          eventName = events.BARGAINS;
          break;

        case 'crosstalkVelocityScale':
          eventName = events.CROSSTALKVELOCITYSCALE;
          break;

        case 'crosstalkTimeWindow':
          eventName = events.CROSSTALKTIMEWINDOW;
          break;

        case 'buttonPresetMode':
          eventName = events.BUTTONPRESETMODE;
          break;

        case 'negativeVelocityOffsets':
          eventName = events.VELOCITYOFFSETS;
          break;

        case 'tares':
          eventName = events.TARES;
          break;

        case 'barDownThresholds':
          eventName = events.BARDOWNTHRESHOLDS;
          break;

        case 'barUpThresholds':
          eventName = events.BARUPTHRESHOLDS;
          break;

        case 'barAvgLow':
          eventName = events.BARAVGLOW;
          break;

        case 'barAvgHigh':
          eventName = events.BARAVGHIGH;
          break;

        case 'barAvgLows':
          eventName = events.BARAVGLOWS;
          break;

        case 'barAvgHighs':
          eventName = events.BARAVGHIGHS;
          break;

        case 'barLowMults':
          eventName = events.BARLOWMULTS;
          break;

        case 'barHighMults':
          eventName = events.BARHIGHMULTS;
          break;

        case 'barLowMult':
          eventName = events.BARLOWMULT;
          break;

        case 'barHighMult':
          eventName = events.BARHIGHMULT;
          break;

        case 'thresholdMult':
          eventName = events.GLOBALTHRESHOLDMULT;
          break;

        case 'calibration':
          eventName = events.CALIBRATION;
          break;

        case 'calibrationGain':
          eventName = events.CALIBRATIONGAIN;
          break;

        default:
      }

      if (device._oscDebug) console.log('<--- osc', parsedOSC); // emit event and payload

      device.emit(eventName, parsedOSC);
      break;

    default:
      device.emit(events.MIDI, data);
  }
}